export class QuickHealthAssessmentModel {


    // id
    id: string | undefined;

    bloodSugarQ1: string | undefined;
    bloodSugarQ2: string | undefined;    
    medicationAndInsulinQ1: string | undefined;
    medicationAndInsulinQ2: string | undefined;
    dietAndExerciseQ1: string | undefined;
    dietAndExerciseQ2: string | undefined;
    symptomsAndWellBeingQ1: string | undefined;
    symptomsAndWellBeingQ2: string | undefined;
    footCareQ1: string | undefined;
    footCareQ2: string | undefined;
    eyeHealthQ1: string | undefined;
    eyeHealthQ2: string | undefined;
    kidneyHealthQ1: string | undefined;
    kidneyHealthQ2: string | undefined;
    cardiovascularHealthQ1: string | undefined;
    cardiovascularHealthQ2: string | undefined;
    overallWellBeingQ1: string | undefined;
    generalHealthHistoryQ1: string | undefined;
    generalHealthHistoryQ2: string | undefined;

}